import { Box, styled } from '@mui/material';

export const AlertWrapper = styled(Box)`
  margin-top: 1rem;
`;
